import React, {useEffect, useState} from 'react';
import {VisitRequestDto} from "../../../../../../modules/vms/dto/VisitRequestDto";
import {FormattedMessage, useIntl} from "react-intl";
import {RequestPlaceDto} from "../../../../../../modules/vms/dto/RequestPlaceDto";
import {Badge, Button, Card, CardContent, CardHeader, IconButton} from "@mui/material";
import {AreaDto} from "../../../../../../modules/vms/dto/AreaDto";
import FormFieldText from "../../../../../../components/FormFieldText";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import RequestArriveTimeSelectableDialog from "../../../../components/RequestArriveTimeSelectableDialog";
import AreaSelectDialog from "../../../../components/AreaSelectDialog";
import {VisitRequestClassify} from "../../../../../../modules/vms/enums/VisitRequestClassify";
import StringUtils from "../../../../../../utils/StringUtils";
import UserSelectDialog from "../../../../../account/components/UserSelectDialog";
import {UserDto} from "../../../../../../modules/account/dto/UserDto";
import FormFieldSelect from "../../../../../../components/FormFieldSelect";

export type VisitRequestProps = {
    visitRequest: VisitRequestDto;
    messageMap: Map<string, string>;
    onChange: (name: string, value: any) => void;
    onChangeVisitRequest: (record: VisitRequestDto) => void;
};

const VisitRequest: React.FC<VisitRequestProps> = (props) => {
    const intl = useIntl();

    // 入场时间选择的对话框
    const [arriveTimeSelectDialogOpen, setArriveTimeSelectDialogOpen] = useState(false);
    // 场所选择的对话框
    const [areaSelectDialogOpen, setAreaSelectDialogOpen] = useState(false);

    const [openUserSelectDialog, setUserSelectDialog] = useState(false);
    // 选择的场所显示字符串
    const [selectedPlaceStr, setSelectedPlaceStr] = useState('');

    useEffect(() => {
    }, []);

    const handleChange = (name: string, value: any) => {
        props.onChange(name, value);
    };

    const handleSelectAreas = (areas: Array<AreaDto>) => {
        const places = new Array<RequestPlaceDto>();
        for (let area of areas) {
            const place = new RequestPlaceDto(area);
            places.push(place);
        }
        handleChange("places", places);
        const selectedPlaceStr = areas.map((area) => {
            return area.name
        }).join(',')

        setSelectedPlaceStr(selectedPlaceStr);
    }

    const handleSelectArriveTime = (arriveDate: string, startTime: string, endTime: string) => {
        const newVisitRequest = {...props.visitRequest};
        newVisitRequest.arriveStartDate = arriveDate;
        newVisitRequest.arriveEndDate = arriveDate;
        newVisitRequest.arriveStartTime = startTime;
        newVisitRequest.arriveEndTime = '235959';
        props.onChangeVisitRequest(newVisitRequest);
    }

    const handleSelectHost = (user: UserDto) => {
        const newVisitRequest = {...props.visitRequest};
        newVisitRequest.hostMobile = user.mobile;
        newVisitRequest.hostFullName = user.fullName;
        props.onChangeVisitRequest(newVisitRequest);
    }

    return (
        <Card>
            <RequestArriveTimeSelectableDialog open={arriveTimeSelectDialogOpen}
                                               classify={VisitRequestClassify.Enum.Shipping}
                                               onClose={() => setArriveTimeSelectDialogOpen(false)}
                                               onSelect={((date, startTime, endTime) => handleSelectArriveTime(date, startTime, endTime))}/>
            <AreaSelectDialog open={areaSelectDialogOpen} onClose={() => setAreaSelectDialogOpen(false)}
                              onOk={handleSelectAreas}/>

            <UserSelectDialog open={openUserSelectDialog}
                              onSelect={(value) => handleSelectHost(value)}
                              onClose={() => setUserSelectDialog(false)}/>
            <CardHeader title={intl.formatMessage({id: 'VMS_VISIT_REQUEST_GENERAL_INFO'})}/>
            <CardContent>
                <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_ARRIVE_TIME"})}
                               disabled={true} required={true} errorText={props.messageMap.get("arriveStartDate")}
                               value={
                                   props.visitRequest.arriveStartDate ?
                                       StringUtils.formatDate(props.visitRequest.arriveStartDate) + " " + StringUtils.formatTime(props.visitRequest.arriveStartTime) + "~" + StringUtils.formatTime(props.visitRequest.arriveEndTime) : ''}
                               endAdornment={
                                   <IconButton color="primary" onClick={() => setArriveTimeSelectDialogOpen(true)}>
                                       <CalendarMonthIcon/>
                                   </IconButton>}/>
                <FormFieldSelect label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PURPOSE"})}
                                 required={true} errorText={props.messageMap.get("purpose")}
                                 value={props.visitRequest.purpose}
                                 onChange={(value) => {
                                     props.onChange("purpose", value)
                                 }}
                                 items={[{
                                     label: intl.formatMessage({id: 'VMS_VISIT_REQUEST_PURPOSE_LOADING'}),
                                     value: intl.formatMessage({id: 'VMS_VISIT_REQUEST_PURPOSE_LOADING'})
                                 }, {
                                     label: intl.formatMessage({id: 'VMS_VISIT_REQUEST_PURPOSE_DISCHARGE'}),
                                     value: intl.formatMessage({id: 'VMS_VISIT_REQUEST_PURPOSE_DISCHARGE'})
                                 }]}/>
                <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PLACE"})}
                               disabled={true} required={true} errorText={props.messageMap.get("places")}
                               value={selectedPlaceStr}
                               endAdornment={
                                   <Badge badgeContent={props.visitRequest.places.length} color="secondary"
                                          overlap="rectangular">
                                       <Button color="primary" onClick={() => setAreaSelectDialogOpen(true)}>
                                           <FormattedMessage id="VMS_VISIT_REQUEST_PLACE_SELECT"/>
                                       </Button>
                                   </Badge>}/>

                <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NAME"})}
                               disabled={true} required={true} errorText={props.messageMap.get("hostName")}
                               value={props.visitRequest.hostFullName}
                               endAdornment={
                                   <Button color="primary" onClick={() => setUserSelectDialog(true)}>
                                       <FormattedMessage id="VMS_VISIT_REQUEST_HOST_SELECT"/>
                                   </Button>}/>
                <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_MOBILE"})}
                               disabled={true} required={true} errorText={props.messageMap.get("hostMobile")}
                               value={props.visitRequest.hostMobile}/>
            </CardContent>
        </Card>
    );
};

export default VisitRequest;